import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Eye, ListPlus, RefreshCw, Rotate3d } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { selectDesignVerificationEnabled } from '@features/featureFlags/featureFlagsSlice';
import { useAppSelector } from '@store/index';

interface ResultsHeaderProps {
  onNewAnalysis: () => void;
  onOpenConvertDialog: () => void;
  onPreview?: () => void;
  canViewAll3D: boolean;
  onView3DAll: () => void;
  onExport: () => void;
  isExporting: boolean;
}

const ResultsHeader: React.FC<ResultsHeaderProps> = ({
  onNewAnalysis,
  onOpenConvertDialog,
  onPreview,
  canViewAll3D,
  onView3DAll,
  onExport,
  isExporting,
}) => {
  const { t } = useTranslation();
  const designVerificationEnabled = useAppSelector(selectDesignVerificationEnabled);

  return (
    <div className="mb-6 flex justify-between items-center">
      <div>
        <h2 className="text-lg font-semibold mb-1">
          {t('drbfm.results.title')}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t('drbfm.results.description')}
        </p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onNewAnalysis}>
          <RefreshCw />
          {t('drbfm.results.newAnalysis')}
        </Button>
        {designVerificationEnabled !== false && (
          <Button
            variant="outline"
            className="border-success/40 text-success hover:bg-success/10 hover:text-success"
            onClick={onOpenConvertDialog}
          >
            <ListPlus />
            {t('drbfm.convert.buttonLabel', '検証項目に変換')}
          </Button>
        )}
        {onPreview && (
          <Button variant="outline" onClick={onPreview}>
            <Eye />
            {t('drbfm.history.preview', 'プレビュー')}
          </Button>
        )}
        {canViewAll3D && (
          <Button
            variant="outline"
            className="border-primary/40 text-primary hover:bg-primary/10 hover:text-primary"
            onClick={onView3DAll}
          >
            <Rotate3d />
            {t('drbfm.cadLink.bulkView', '3Dで一括表示')}
          </Button>
        )}
        <Button onClick={onExport} disabled={isExporting}>
          <Download />
          {isExporting
            ? t('drbfm.results.exporting')
            : t('drbfm.history.exportExcel', 'Excel出力')}
        </Button>
      </div>
    </div>
  );
};

export default ResultsHeader;
